/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import { format } from 'date-fns';

const datasetParams = {
  mainFile: 'Web/trafficConversion/default/fullData_combined.csv',
  runDetailsFile: 'Web/trafficConversion/default/fullData_runDetails.csv',
  tableName: 'trafficConversion',
  mainDateField: 'Date',
  headersRemaps: {
    date: 'Date',
    sessionCustomChannelGroup: 'OriginalChannel',
    Channel_remapped: 'Channel',
  },
  calculatedMetrics: {
    conversionRate: {
      numerator: 'transactions',
      denominator: 'sessions',
    },
    engagedConversionRate: {
      numerator: 'transactions',
      denominator: 'engagedSessions',
    },
    bounceRate: {
      numerator: 'bouncedSessions',
      denominator: 'sessions',
    },
  },
  metrics: {
    Users: {
      fieldName: 'totalUsers',
      displayName: 'Users',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    Sessions: {
      fieldName: 'sessions',
      displayName: 'Sessions',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    EngagedSessions: {
      fieldName: 'engagedSessions',
      displayName: 'Engaged Sessions',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    BouncedSessions: {
      fieldName: 'bouncedSessions',
      displayName: 'Bounced Sessions',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    BounceRate: {
      fieldName: 'bounceRate',
      displayName: 'Bounce Rate',
      chartFormat: ',.0%',
      format: {
        style: 'percent',
        maximumFractionDigits: 1,
      },
    },
    Transactions: {
      fieldName: 'transactions',
      displayName: 'Transactions',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    ConversionRate: {
      fieldName: 'conversionRate',
      displayName: 'Conversion Rate',
      chartFormat: ',.0%',
      format: {
        style: 'percent',
        maximumFractionDigits: 1,
      },
    },
    engagedConversionRate: {
      fieldName: 'engagedConversionRate',
      displayName: 'Engaged Conversion Rate',
      chartFormat: ',.0%',
      format: {
        style: 'percent',
        maximumFractionDigits: 1,
      },
    },
    Revenues: {
      fieldName: 'totalRevenue',
      displayName: 'Revenues',
      chartFormat: '$~s',
      format: {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      },
    },
  },
  valuesRemaps: {
    Channel: {
      'Organic Search': 'Organic Search',
      'Paid Search': 'Paid Search',
      Direct: 'Direct',
      Email: 'Email',
      Display: 'Display',
      Referral: 'Referral',
      Affiliates: 'Affiliates',
      // Social: 'Social',
      'Paid Social': 'Paid Social',
      'Organic Social': 'Organic Social',
      'Paid Video': 'OLV',
      OLV: 'OLV',
    },
  },
  transformRow: (row) => ({
    ...row,
    Date: format(new Date(row.Date), 'yyyy-MM-dd'),
    Year: format(new Date(row.Date), 'yyyy'),
    YearMonth: format(new Date(row.Date), 'yyyy-MM'),
    bouncedSessions: row.sessions - row.engagedSessions,
  }),
  filterDimensions: {
    subset: {
      order: 'asc',
      customOrder: ['All', 'All_Not_$0', 'International', 'US_only', 'US_$0only', 'US_Not_$0'],
      // singleSelect: true,
    },
    Park: {
      order: 'asc',
      customOrder: ['SWF', 'APO', 'DCO', 'BGT', 'AIT', 'SWC', 'SPC', 'SWT', 'APT', 'BGW', 'WCW', 'SPL'],
    },
    Date: {
      // order: 'desc',
      sortType: 'alpha',
    },
    Year: {
      // order: 'desc',// Gets overridden by the getFilterValues special case
      sortType: 'alpha',
    },
    YearMonth: {
      // order: 'desc',// Gets overridden by the getFilterValues special case
      sortType: 'alpha',
    },
    OriginalChannel: {
      order: 'desc',
      customOrder: ['Organic Search', 'Paid Search', 'Direct', 'Email', 'Social', 'Paid Social', 'Organic Social', 'Display', 'Referral', 'Affiliates', 'OLV'],
    },
    Channel: {
      order: 'desc',
      customOrder: ['Organic Search', 'Paid Search', 'Direct', 'Email', 'Social', 'Paid Social', 'Organic Social', 'Display', 'Referral', 'Affiliates', 'OLV'],
    },
  },
};

export default datasetParams;
